import { ShowChartRounded } from "@mui/icons-material";
import {
  Paper,
  Grid,
  Typography,
  useTheme,
  IconButton,
  Box,
} from "@mui/material";

type KeyNumberProps = {
  title: string;
  value: number | Record<string, number> | string;
  handleHistoryPopup: () => void;
  icon?: React.ReactElement;
  children?: any;
  historyButton?: boolean;
};

const KeyNumber: React.FC<KeyNumberProps> = ({
  title,
  value,
  handleHistoryPopup,
  icon,
  children,
  historyButton = true
}) => {
  const THRESHOLD = 20;
  const theme = useTheme();

  const RenderStatusCount = () => {
    return Object.entries(value).map(([key, val]) => {
      const isLow = val < THRESHOLD && icon;
      const textColor = isLow ? "red" : theme.palette.text.primary;
      return (
        <Box
          key={key}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 0.5,
            gap: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
            }}
          >
            <Typography variant="body1" color={textColor}>
              {key}:
            </Typography>
            <Typography variant="body1" color={textColor} textAlign={"right"}>
              {val}
            </Typography>
          </Box>
          <Box
            sx={{
              visibility: isLow ? "visible" : "hidden",
            }}
          >
            {icon}
          </Box>
        </Box>
      );
    });
  };

  return (
    <Grid item xs={12} sm>
      <Paper
        sx={{
          px: 3,
          py: 3,
          flexDirection: "column",
          borderRadius: 2,
          // backgroundColor: "white",
          // boxShadow: "hsla(210, 8%, 60%, 0.2) 0px 8px 24px",
          height: "100%",
        }}
      >
        {children || (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            {/* Left Section */}
            <Box>
              <Typography
                variant="h6"
                sx={{
                  color: theme.palette.text.secondary,
                  fontWeight: "normal",
                }}
              >
                {title}
              </Typography>
              {typeof value === "object" ? (
                <RenderStatusCount />
              ) : (
                <Typography
                  // variant="h6"
                  sx={{ color: theme.palette.text.primary }}
                >
                  {value}
                </Typography>
              )}
            </Box>

            {/* Right Section */}
            {historyButton && <IconButton onClick={handleHistoryPopup} sx={{ p: 2 }}>
              <ShowChartRounded />
            </IconButton>}
          </Box>
        )}
      </Paper>
    </Grid>
  );
};

export default KeyNumber;
